import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Col} from "@pg-design/grid-module";
import {calculateRemSize, mr, mt, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps} from "../../offer/list/hooks/use_list_dynamic_positions";
import {OfferType} from "../../offer/types/OfferType";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {RegionType} from "../../region/types/RegionType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";
import {ForYouBannerGtmEvent} from "../tracking/for_you_banner_gtm_events";
import {ConsultantBox} from "./ConsultantBox";

const background = require("../images/for_you_banner.png");

interface IProps {
    offerTypes: OfferType[];
    selectedRegion: ISelectedRegion[];
}

export const ForYouBanner = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const {data: regions} = useGetRegionDetailListQuery(
        {regionIds: props.selectedRegion.map((region) => region.id)},
        {skip: props.selectedRegion.length === 0}
    );

    const getRegionCity = () => {
        const cityInRegions = regions?.length && regions.find((region) => region.type === RegionType.CITY);
        if (cityInRegions) {
            return cityInRegions.name;
        }
        if (regions) {
            return regions[0]?.parent?.name || "";
        }
        return "";
    };
    return (
        <Col sm={4} md={12} lg={16} as="li" {...disableDynamicPositionProps()}>
            <div css={bannerWrapper}>
                <Image width="100%" height="100%" alt="tło banera" src={background} css={imageStyle} />
                <div css={bannerTexts}>
                    <Text variant="headline_2" as="p">
                        Nie masz czasu przeglądać wszystkich ofert?
                    </Text>

                    <Text variant="body_copy_1">
                        Powiedz mi, jakiego mieszkania szukasz, a <b>bezpłatnie i szybko</b> znajdę dla Ciebie oferty spełniające Twoje oczekiwania oraz doradzę
                        w wyborze najlepszej!
                    </Text>

                    <ConsultantBox />
                </div>

                <Button
                    variant="filled_secondary"
                    size={isMobile ? "medium" : "big"}
                    onClick={() => {
                        ForYouBannerGtmEvent(getRegionCity());
                        dispatch(openForYouModal(props.offerTypes));
                    }}
                >
                    wyszukaj dla mnie
                </Button>
            </div>
        </Col>
    );
};

const bannerWrapper = css`
    position: relative;
    background-color: ${getThemeVariable("colors.background.200")};
    ${p(3.5, 1.5, 5, 1.5)};
    border-radius: ${calculateRemSize(2)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: ${calculateRemSize(3)};
    max-width: 375px;
    margin: auto;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3, 8, 3, 8)};
        gap: ${calculateRemSize(2)};
        flex-direction: row;
        max-width: unset;
    }

    @media (min-width: ${getThemeBreakpoint().lg}) {
        gap: ${calculateRemSize(3)};

        > button {
            ${mr(4)};
        }
    }
`;

const imageStyle = css`
    display: none;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: block;
        position: absolute;
        inset: 0;
        opacity: 50%;
    }
`;

const bannerTexts = css`
    display: flex;
    gap: ${calculateRemSize(1)};
    flex-direction: column;
    align-items: center;

    > p {
        text-align: center;
    }

    .consultant-box {
        ${mt(2)};
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        align-items: start;
        max-width: 656px;
        z-index: 1;

        > p {
            text-align: unset;
        }
    }

    @media (min-width: ${getThemeBreakpoint().lg}) {
        max-width: 784px;
    }
`;
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Col} from "@pg-design/grid-module";
import {calculateRemSize, mr, mt, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps} from "../../offer/list/hooks/use_list_dynamic_positions";
import {OfferType} from "../../offer/types/OfferType";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {RegionType} from "../../region/types/RegionType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";
import {ForYouBannerGtmEvent} from "../tracking/for_you_banner_gtm_events";
import {ConsultantBox} from "./ConsultantBox";

const background = require("../images/for_you_banner.png");

interface IProps {
    offerTypes: OfferType[];
    selectedRegion: ISelectedRegion[];
}

export const ForYouBanner = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const {data: regions} = useGetRegionDetailListQuery(
        {regionIds: props.selectedRegion.map((region) => region.id)},
        {skip: props.selectedRegion.length === 0}
    );

    const getRegionCity = () => {
        const cityInRegions = regions?.length && regions.find((region) => region.type === RegionType.CITY);
        if (cityInRegions) {
            return cityInRegions.name;
        }
        if (regions) {
            return regions[0]?.parent?.name || "";
        }
        return "";
    };
    return (
        <Col sm={4} md={12} lg={16} as="li" {...disableDynamicPositionProps()}>
            <div css={bannerWrapper}>
                <Image width="100%" height="100%" alt="tło banera" src={background} css={imageStyle} />
                <div css={bannerTexts}>
                    <Text variant="headline_2" as="p">
                        Nie masz czasu przeglądać wszystkich ofert?
                    </Text>

                    <Text variant="body_copy_1">
                        Powiedz mi, jakiego mieszkania szukasz, a <b>bezpłatnie i szybko</b> znajdę dla Ciebie oferty spełniające Twoje oczekiwania oraz doradzę
                        w wyborze najlepszej!
                    </Text>

                    <ConsultantBox />
                </div>

                <Button
                    variant="filled_secondary"
                    size={isMobile ? "medium" : "big"}
                    onClick={() => {
                        ForYouBannerGtmEvent(getRegionCity());
                        dispatch(openForYouModal(props.offerTypes));
                    }}
                >
                    wyszukaj dla mnie
                </Button>
            </div>
        </Col>
    );
};

const bannerWrapper = css`
    position: relative;
    background-color: ${getThemeVariable("colors.background.200")};
    ${p(3.5, 1.5, 5, 1.5)};
    border-radius: ${calculateRemSize(2)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: ${calculateRemSize(3)};
    max-width: 375px;
    margin: auto;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3, 8, 3, 8)};
        gap: ${calculateRemSize(2)};
        flex-direction: row;
        max-width: unset;
    }

    @media (min-width: ${getThemeBreakpoint().lg}) {
        gap: ${calculateRemSize(3)};

        > button {
            ${mr(4)};
        }
    }
`;

const imageStyle = css`
    display: none;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: block;
        position: absolute;
        inset: 0;
        opacity: 50%;
    }
`;

const bannerTexts = css`
    display: flex;
    gap: ${calculateRemSize(1)};
    flex-direction: column;
    align-items: center;

    > p {
        text-align: center;
    }

    .consultant-box {
        ${mt(2)};
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        align-items: start;
        max-width: 656px;
        z-index: 1;

        > p {
            text-align: unset;
        }
    }

    @media (min-width: ${getThemeBreakpoint().lg}) {
        max-width: 784px;
    }
`;
